import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

export const superAdminGuard: CanActivateFn = () => {
  const auth   = inject(AuthService);
  const router = inject(Router);
  const notify = inject(NotificationService);

  if (auth.user()?.rol === 'super_admin') return true;

  notify.error('Esta sección es exclusiva para administradores de Softion.', 'Acceso denegado');
  void router.navigate(['/']);
  return false;
};
